import React from 'react';
import RsvpControls from './RSVPControls';
import { useRsvp } from './hooks/useRSVP';
import EventWaitlistControls from './EventWaitlistControls';

function FamilyMemberRsvpPanel({
  form,
  teamId,
  actorUserId,
  occurrenceIdOverride,
  member,
  rsvpSeriesResponsesEnabled = true,
  readOnly = false,
  readOnlyMessage = '',
}) {
  const {
    myRsvpStatus,
    myOccurrenceRsvpStatus,
    mySeriesRsvpStatus,
    rsvpBusy,
    currentYesCount,
    capacityRemaining,
    capacityNum,
    isFull,
    isRecurring,
    occurrenceId,
    setRsvpStatus,
    resetRsvpStatus,
  } = useRsvp({
    form,
    teamId,
    userId: member.id,
    actorUserId,
    occurrenceIdOverride,
    rsvpSeriesResponsesEnabled,
  });

  return (
    <>
    <RsvpControls
      enabled
      title={`${member.name} RSVP`}
      isFull={isFull}
      myRsvpStatus={myRsvpStatus}
      myOccurrenceRsvpStatus={myOccurrenceRsvpStatus}
      mySeriesRsvpStatus={mySeriesRsvpStatus}
      isRecurring={isRecurring}
      occurrenceId={occurrenceId}
      setRsvpStatus={setRsvpStatus}
      resetRsvpStatus={resetRsvpStatus}
      rsvpBusy={rsvpBusy}
      capacityNum={capacityNum}
      currentYesCount={currentYesCount}
      capacityRemaining={capacityRemaining}
      rsvpSeriesResponsesEnabled={rsvpSeriesResponsesEnabled}
      readOnly={readOnly}
      readOnlyMessage={readOnlyMessage}
    />
    <EventWaitlistControls form={form} teamId={teamId} userId={actorUserId} targetUserId={member.id} isAdmin={false} occurrenceId={occurrenceId} isFull={isFull} />
    </>
  );
}

export default function FamilyMemberRsvpPanels({
  form,
  teamId,
  actorUserId,
  occurrenceIdOverride = null,
  rsvpSeriesResponsesEnabled = true,
  members = [],
  readOnly = false,
  readOnlyMessage = '',
}) {
  if (!Array.isArray(members) || members.length === 0) return null;

  return (
    <details className="card" style={{ marginTop: 12 }}>
      <summary style={{ cursor: 'pointer', fontWeight: 600 }}>
        Family members ({members.length})
      </summary>
      <div style={{ marginTop: 12, display: 'grid', gap: 10 }}>
        {members.map((member) => (
          <details
            key={member.id}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 10,
              padding: 10,
              background: '#fff',
            }}
          >
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>
              {member.name}
            </summary>
            <div style={{ marginTop: 10 }}>
              <FamilyMemberRsvpPanel
                form={form}
                teamId={teamId}
                actorUserId={actorUserId}
                occurrenceIdOverride={occurrenceIdOverride}
                member={member}
                rsvpSeriesResponsesEnabled={rsvpSeriesResponsesEnabled}
                readOnly={readOnly}
                readOnlyMessage={readOnlyMessage}
              />
            </div>
          </details>
        ))}
      </div>
    </details>
  );
}
